// extracted by mini-css-extract-plugin
export default {"page":"styles_page__caIal","card":"styles_card__gxzey","content":"styles_content__ieuR4","fields":"styles_fields__oxqPX","checks":"styles_checks__XW8e8"};